import { useState } from "react";
import { IoMdCheckmark } from "react-icons/io";
import { MdKeyboardArrowDown } from "react-icons/md";
import { RiCloseLargeFill } from "react-icons/ri";
import { HiOutlineStatusOnline } from "react-icons/hi";
import { TiThSmall } from "react-icons/ti";
import SlidingModal from "../../SlidingModal";
import CustomDialog from "@/components/ui/customDialog";
export default function StatusFilter({
  txStatusFilter,
  setTxStatusFilter,
  isMobile = true
}) {
  const [isModalStatusOpen, setIsModalStatusOpen] = useState(false);
  function toggleStatusModal() {
    setIsModalStatusOpen(!isModalStatusOpen);
  }
  const [openModal, setOpenModal] = useState(false);
  function toggleOpenModal() {
    setOpenModal(!openModal);
  }
  const ModalContent = () => {
    return <>
                <div onClick={() => {
        setTxStatusFilter('success');
        toggleStatusModal();
        setOpenModal(false);
      }} className={`cursor-pointer text-[16px] flex items-center px-4 pt-4 w-full ${txStatusFilter === "success" ? "text-genius-cream" : "text-genius-cream/50"}`}>
                    <IoMdCheckmark className='w-[22px] h-[22px] mr-4 text-green-400' data-sentry-element="IoMdCheckmark" data-sentry-source-file="StatusFilter.tsx" />
                    Success
                </div>
                <div onClick={() => {
        setTxStatusFilter('failed');
        toggleStatusModal();
        setOpenModal(false);
      }} className={`cursor-pointer text-[16px] flex items-center px-4 pt-4 w-full ${txStatusFilter === "failed" ? "text-genius-cream" : "text-genius-cream/50"}`}>
                    <RiCloseLargeFill className='w-[22px] h-[22px] mr-4 text-red-400' data-sentry-element="RiCloseLargeFill" data-sentry-source-file="StatusFilter.tsx" />
                    Failed
                </div>
                <div onClick={() => {
        setTxStatusFilter(null);
        toggleStatusModal();
        setOpenModal(false);
      }} className={`cursor-pointer text-[16px] flex items-center px-4 pt-4 w-full ${txStatusFilter === null ? "text-genius-cream" : "text-genius-cream/50"}`}>
                    <TiThSmall className='w-[22px] h-[22px] mr-4' data-sentry-element="TiThSmall" data-sentry-source-file="StatusFilter.tsx" />
                    All
                </div>
            </>;
  };
  const ModalTrigger = () => {
    return <div onClick={() => isMobile ? toggleStatusModal() : toggleOpenModal()} className="capitalize rounded-lg w-fit px-4 h-[37px] border-genius-blue border-[1px] float-right text-[14px] flex items-center cursor-pointer" data-sentry-component="ModalTrigger" data-sentry-source-file="StatusFilter.tsx">
                {txStatusFilter === 'success' ? <>
                        <IoMdCheckmark className="text-green-400 cursor-pointer mr-2" /> Success
                    </> : txStatusFilter === 'failed' ? <>
                        <RiCloseLargeFill className="text-red-400 mr-2 cursor-pointer" /> Failed
                    </> : <>
                        <TiThSmall className="mr-2 cursor-pointer" /> All
                    </>}
                <MdKeyboardArrowDown className="ml-2" data-sentry-element="MdKeyboardArrowDown" data-sentry-source-file="StatusFilter.tsx" />
            </div>;
  };
  return <div className='flex justify-between w-full' data-sentry-component="StatusFilter" data-sentry-source-file="StatusFilter.tsx">
            <div className='w-2/4 flex itemsn-center'>
                <p className='text-genius-cream text-[16px] flex items-center'>
                    <HiOutlineStatusOnline className='w-[22px] h-[22px] ' data-sentry-element="HiOutlineStatusOnline" data-sentry-source-file="StatusFilter.tsx" />
                    <span className='ml-2 text-genius-cream/50'>Status</span>
                </p>
            </div>
            <div className='w-2/4'>
                {!isMobile ? <>
                        <ModalTrigger />
                        <CustomDialog hideClose={true} toggleModal={toggleOpenModal} isOpen={openModal} className={'h-[200px] w-[400px] pt-10 px-0'}>
                            <ModalContent />
                        </CustomDialog>
                    </> : <>
                        <ModalTrigger />
                        <SlidingModal isOpen={isModalStatusOpen} onClose={toggleStatusModal} heightFit={true}>
                            <ModalContent />
                        </SlidingModal>
                    </>}
            </div>
        </div>;
}